// extracted by mini-css-extract-plugin
module.exports = {"waveOuterDiv":"WaveFormMobile_waveOuterDiv__mN2dG","waveInnerDiv":"WaveFormMobile_waveInnerDiv__2VmTt","waveform":"WaveFormMobile_waveform__3r99b"};